import React, { useState, useEffect } from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import { Button } from "devextreme-react";
import { criarMunicipioDs } from "../../DataSources";
import DataSource from "devextreme/data/data_source";

const BaixarNotas = () => {
  const [estado, setEstado] = useState({
    municipioId: undefined,
    inscricaoMunicipal: undefined,
    cnpj: "",
    tipoFiltro: 0,
    dataInicial: undefined,
    dataFinal: undefined,
    numeroInicial: undefined,
    numeroFinal: undefined,
  });

  const [filtro, setFiltro] = useState({
    filtroSelecionado: 0,
    listaFiltros: [
      { id: 0, descricao: "Escolha um filtro..." },
      { id: 1, descricao: "Por data" },
      { id: 2, descricao: "Por número" },
    ],
  });

  const municipiosDs = [];

  useEffect(() => {
    criarMunicipioDs()
      .load()
      .then((data) => {
        data.map((x) => {
          municipiosDs.push(x);
        });
      });
  }, []);

  const municipiosStore = new DataSource({
    store: {
      data: municipiosDs,
      type: "array",
      key: "id",
    },
  });

  function onChange(e) {
    //e.preventDefault();
    console.log(e);
    setFiltro({...filtro, filtroSelecionado: e.value});
  }

  function retornaCamposFiltro() {
    if (filtro.filtroSelecionado === 1) {
      return (
        <GroupItem colSpan={1} colCount={3}>
          <SimpleItem
            dataField={"dataInicial"}
            editorType={"dxDateBox"}
            editorOptions={{ width: "100%" }}
            colSpan={1}
          >
            <Label text="Data Inicial" />
          </SimpleItem>
          <SimpleItem
            dataField={"dataFinal"}
            editorType={"dxDateBox"}
            editorOptions={{ width: "100%" }}
            colSpan={1}
          >
            <Label text="Data Final" />
          </SimpleItem>
        </GroupItem>
      );
    } else {
      return (
        <GroupItem colSpan={1} colCount={3}>
          <SimpleItem dataField={"numeroInicial"} colSpan={1}>
            <Label text="Número Inicial" />
          </SimpleItem>
          <SimpleItem dataField={"numeroFinal"} colSpan={1}>
            <Label text="Número Final" />
          </SimpleItem>
        </GroupItem>
      );
    }
  }

  const municipioOptions = {
    editorType: "dxSelectBox",
    searchEnabled: true,
    searchPlaceholder: "Procurar",
    cancelButtonText: "Cancelar",
    noDataText: "Nenhum registo encontrado",
    placeholder: "Selecione um município",
    dataSource: municipiosStore,
    valueExpr: "id",
    displayExpr: "nome",
    searchMode: "contains",
  };

  const filtroOptions = {
    editorType: "dxSelectBox",
    searchEnabled: false,
    placeholder: filtro.listaFiltros[0].descricao,
    dataSource: filtro.listaFiltros,
    defaultValue: filtro.filtroSelecionado,
    valueExpr: "id",
    displayExpr: "descricao",
    onValueChanged: (e) => onChange(e),
  };

  return (
    <div className={"content-block dx-card responsive-paddings"}>
      <form>
        <Form formData={estado} colCount={1}>
          <GroupItem caption="Imprimir Notas" colSpan={1} colCount={3}>
            <SimpleItem
              dataField={"municipioId"}
              editorType={"dxLookup"}
              editorOptions={municipioOptions}
              colSpan={1}
            >
              <Label text="Município" />
            </SimpleItem>

            <SimpleItem colSpan={1} dataField={"inscricaoMunicipal"}>
              <Label text="Incrição Municipal" />
            </SimpleItem>

            <SimpleItem
              editorOptions={{ mask: "00.000.000/0000-00" }}
              colSpan={1}
              dataField={"cnpj"}
            >
              <Label text="CNPJ" />
            </SimpleItem>

            <SimpleItem
              dataField={"tipoFiltro"}
              editorType={"dxLookup"}
              editorOptions={filtroOptions}
              colSpan={1}
            >
              <Label text="Filtro" />
            </SimpleItem>
          </GroupItem>
          {filtro.filtroSelecionado === 0 ? null : retornaCamposFiltro()}
        </Form>
      </form>
    </div>
  );
};

export default BaixarNotas;
